export default __webpack_public_path__ + "static/media/logo.3f268f11.png";